import { PdPopupDialog } from "./pd-popup-dialog/PdPopupDialog.js";
//#region src/pd-popup-dialog/pd-popup-dialog.ts
var tag = "pd-popup-dialog";
if (!customElements.get(tag)) customElements.define(tag, PdPopupDialog);
//#endregion
export { PdPopupDialog };
